import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export enum FIELD_TYPE {
  NUMBER,
  TEXT,
  TEXTAREA,
  SELECT,
  MULTISELECT,
  BOOLCHOICE,
  DATEPICKER,
  PHONE,
  UPLOAD
}

export interface IOption {
  id: string;
  name: string;
  type?: racehorse360.FacilityType;
  options?: IOption[];
}

export interface IField {
  name: string;
  label: string;
  previewLabel?: string;
  placeholder?: string;
  type: FIELD_TYPE;
  width?: number;
  mobileWidth?: number;
  disabled?: boolean;
  optional?: boolean;
  maxLength?: number;
  options?: IOption[];
  min?: Date | number;
  initialFocusedDate?: Date | number;
  isValidated?: boolean;
  shouldApplyMobileStyles?: boolean;
}
